import React, { ReactElement } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Snackbar from '@material-ui/core/Snackbar';
import Button from '@material-ui/core/Button';
import { Alert, AlertTitle } from '@material-ui/lab';
import { colors } from '../../../theme';

type Props = {
  isLatestVersion: boolean;
  onClearCache: () => void;
};

const useStyles = makeStyles({
  versionNotificationToast: {
    backgroundColor: colors.madison,
    color: colors.white,
  },
  versionNotificationToastTitle: {
    color: colors.white,
  },
  versionNotificationToastButton: {
    color: colors.bright_turquoise,
  },
});

const ClearCacheAlert = ({
  isLatestVersion,
  onClearCache,
}: Props): ReactElement => {
  const classes = useStyles();
  return (
    <Snackbar
      data-testid="version-expired-snackbar"
      open={!isLatestVersion}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
    >
      <Alert
        data-testid="version-expired-snackbar-content"
        variant="filled"
        severity="info"
        className={classes.versionNotificationToast}
        action={
          <Button
            size="small"
            className={classes.versionNotificationToastButton}
            onClick={onClearCache}
          >
            Actualizar
          </Button>
        }
      >
        <AlertTitle className={classes.versionNotificationToastTitle}>
          Nueva versión disponible
        </AlertTitle>
        Presione &quot;actualizar&quot; para utilizar la última versión de la
        aplicación.
      </Alert>
    </Snackbar>
  );
};

export default ClearCacheAlert;
